import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { postLmsSettings } from '../../actions'
import { routePaths } from '../../urls'
import { useStateValue } from '@State'
import { Alert } from '../Alert.js'

export const SetupForm = () => {
  const [state, dispatch] = useStateValue()
  const history = useHistory()
  const [canvasUrlInput, setCanvasUrlInput] = useState(state.canvasUrl || '')

  useEffect(() => {
    setCanvasUrlInput(state.canvasUrl || '')
  }, [state.canvasUrl])

  const postFormData = async event => {
    event.preventDefault()
    const result = await postLmsSettings({ canvasUrl: canvasUrlInput }, dispatch)
    if (result) {
      history.push(routePaths.canvasAuthorize)
    }
  }

  let msg =
    state.formErrorMsg === '' ? null : (
      <Alert bootstrapClass={state.msgClass} message={state.formErrorMsg} />
    )

  return (
    <div>
      {msg}
      <form onSubmit={postFormData} className="canvas-settings-form">
        <label>
          Institution Canvas URL:{' '}
          <input
            className="canvas-setting"
            type="text"
            name="lms_url"
            value={canvasUrlInput}
            onChange={e => setCanvasUrlInput(e.target.value)}
          />
        </label>
        <div className="help-text">
          <p className="text-warning">
            If you are unsure about your institution&apos;s URL, please{' '}
            <a href="/contact">contact us.</a>
          </p>
        </div>
        <br />
        <div className="form-control-wrapper">
          <button
            className="btn btn-myed btn-primary btn-primary-myed"
            type="submit"
          >
            Next <div className="fa-solid fa-chevron-right ml-2" />
          </button>
        </div>
      </form>
    </div>
  )
}

